import classNames from 'classnames';
import React from 'react';
import { PartnerLogos } from './partner-logos.react-component';
import styles from "./partners-banner.module.css";

/** React prop interface for `PartnersBanner` component */

/**
 * ### PartnersBanner
 *
 * Renders a grouping of SVG logos for companies that use Udemy for Business.
 */
export const PartnersBanner = ({
  heading,
  headingClassName,
  logos,
  className = '',
  headingAlignment = 'center'
}) => {
  // Determine the alignment class based on the headingAlignment prop
  const alignmentClass = {
    left: styles['left-aligned-heading'],
    center: styles['center-aligned-heading'],
    right: styles['right-aligned-heading']
  }[headingAlignment];
  return /*#__PURE__*/React.createElement("div", {
    className: styles.wrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.content, className)
  }, /*#__PURE__*/React.createElement("h2", {
    className: classNames(headingClassName, styles.heading, alignmentClass)
  }, heading), /*#__PURE__*/React.createElement(PartnerLogos, {
    logos: logos
  })));
};
//# sourceMappingURL=partners-banner.react-component.js.map